import { defineComponent as _defineComponent } from 'vue';
import { onMounted, onUnmounted } from 'vue';
import useModal from '@/composables/modal';
export default /*#__PURE__*/ _defineComponent({
    __name: 'modal',
    props: {
        closable: { type: Boolean, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { setModal } = useModal();
        const siteContent = document.querySelector('.site-content');
        onMounted(() => {
            if (siteContent) {
                siteContent.style.top = `${-window.pageYOffset}px`;
            }
            document.body.classList.add('custom-modal-open');
            window.scrollTo(0, 0);
            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape') {
                    setModal('');
                }
            });
        });
        onUnmounted(() => {
            document.body.classList.remove('custom-modal-open');
            document.removeEventListener('keyup', () => setModal(''));
            if (siteContent) {
                const scrollOffset = Math.abs(parseFloat(siteContent.style.top));
                siteContent.style.removeProperty('top');
                window.scrollTo(0, scrollOffset);
            }
        });
        const __returned__ = { props, setModal, siteContent };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
